import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import CircularProgress from 'material-ui/CircularProgress';
import styles from 'styles';

import { getStatisticsVesselPositions } from 'actions/statistics/vesselPositions';
import { getStatisticsCargoRequests } from 'actions/statistics/cargoRequests';

import RangeDates from './RangeDates';

import VesselPositionsChart from './VesselPositionsChart';
import CargoRequestsChart from './CargoRequestsChart';

class StatisticsMonitorPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            from: moment().startOf('day').add(-1, 'month').toDate(),
            until: moment().startOf('day').toDate(),
        };

        this.changeDateRange = this.changeDateRange.bind(this);
    }

    changeDateRange(from, until) {
        this.setState({
            from,
            until,
        });
    }

    UNSAFE_componentWillMount() {
        const { from, until } = this.state;

        this.props.getStatisticsVesselPositions(
            moment(from).utcOffset(0, true).valueOf(),
            moment(until).utcOffset(0, true).valueOf(),
        );

        this.props.getStatisticsCargoRequests(
            moment(from).utcOffset(0, true).valueOf(),
            moment(until).utcOffset(0, true).valueOf(),
        );
    }

    render() {
        const { from, until } = this.state;
        const { isLoadedCargoRequests, isLoadedVesselPositions } = this.props;

        return (
            <div id='statistics-monitor' className='container'>
                <div className="row">
                    <div className="col-xs-6">
                        <h3>Statistics vessel positions</h3>
                    </div>
                    <div className="col-xs-6">
                        <h3>Statistics cargo requests</h3>
                    </div>
                </div>

                {isLoadedCargoRequests && isLoadedVesselPositions ?
                    <div className="row">
                        <div className="col-xs-6">
                            <VesselPositionsChart from={from} until={until} />
                        </div>
                        <div className="col-xs-6">
                            <CargoRequestsChart from={from} until={until} />
                        </div>
                        <div className="col-xs-12">
                            <RangeDates from={from} until={until} changeDateRange={this.changeDateRange} />
                        </div>
                    </div>
                    :
                    <CircularProgress
                        style={styles.circularProgress}
                    />
                }
            </div>
        );
    }
}

export default connect(
    ({ user: { isLogged }, statisticsCargoRequests, statisticsVesselPositions }) => ({
        isLogged,
        isLoadedCargoRequests: statisticsCargoRequests.isLoaded,
        isLoadedVesselPositions: statisticsVesselPositions.isLoaded,
    }),
    dispatch => bindActionCreators(
        {
            getStatisticsVesselPositions,
            getStatisticsCargoRequests,
        },
        dispatch,
    ),
)(StatisticsMonitorPage);



// WEBPACK FOOTER //
// ./app/components/Statistics/Monitor/Page.jsx